import { Component, OnInit } from '@angular/core';
import {AdminService} from "./services/admin.service";
import {Admin} from "./models/admin";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'app-adminview',
    template: `

    <section class="content-header">
    <h1>
        {{ title }}
    </h1>
    <ol class="breadcrumb">
        <li><a href="#" routerLink="/home"><i class="fa fa-dashboard"></i> Dashboard</a></li>
        <li><a href="#" routerLink="/admin"> Admin</a></li>
        <li class="active">{{ admininfo?.vEmailId }}</li>
    </ol>
</section>
<section class="content">
    <div class="row">
        <div class="col-md-12">
            <div class="box box-solid">
                <div class="box-header with-border">
                    <h3 class="box-title">{{ admininfo?.vTitle }}</h3>
                    <div class="pull-right">
                        <a href="#" routerLink="/admin/update/{{ admininfo?.iAdminId }}" class="btn btn-md btn-success btn-flat">Update</a>
                    </div>
                </div>
                <!-- /.box-header -->
                <div class="box-body">
                    <table id="w0" class="table table-striped table-bordered detail-view">
                        <tbody>
                        <tr>
                            <th>Email Id</th>
                            <td>{{ admininfo?.vEmailId }}</td>
                        </tr>
                        <tr>
                            <th>Create Date</th>
                            <td>{{ admininfo?.iCreatedAt * 1000 | date }}</td>
                        </tr>
                        <tr>
                            <th>Update Date</th>
                            <td>{{ admininfo?.iUpdatedAt * 1000 | date }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    </div>
</section>
    
    `
})
export class AdminviewComponent implements OnInit {
    title:string = "Admins";
    admininfo:Admin;
    constructor(
        private adminService:AdminService,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        this.title;
        this.getAdminInfo();
    }

    getAdminInfo=function () {
        this.activatedRoute.params.subscribe(params => {
            let iAdminId = params['id'];
            console.log("iAdminId======>",iAdminId); // Print the parameter to the console.
            this.adminService.getAdminInfo(iAdminId).then(data => {
                console.log("AdminInfo=======>",data['data']);
                this.admininfo = data['data'];
            });
        });

    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/admin/adminview.component.ts